/**
 * Valida si el parametro es de tipo 'number'
 * Infinity es correcto, NaN no.
 *
 * @param {number}
 *
 * @return {boolean}
 */

export function isNumber(num) {
  return typeof num === 'number' && !isNaN(num);
}
